import {
  EventBriefQuestion,
  EnrichedProductService,
  EnrichedProductServiceBundle,
} from 'services/api/entities/events/types/internal/services'
import {
  yupArray,
  yupBoolean,
  yupIgnore,
  yupNumber,
  yupObject,
  YupSchema,
  yupString,
} from 'services/yup'
import { customizationVS } from '../customization'

export const eventBriefQuestionVS: YupSchema<EventBriefQuestion> =
  yupObject().shape({
    id: yupIgnore(),
    mandatory: yupIgnore(),
    type: yupIgnore(),
    response: yupString().optional(),
    text: yupIgnore(),
    options: yupArray(),
    status: yupIgnore(),
    notActiveWhenServices: yupArray(),
    products: yupArray(yupNumber()),
  })

export const enrichedProductServiceVS: YupSchema<EnrichedProductService> =
  yupObject().shape({
    briefConfirmed: yupIgnore(),
    briefQuestions: yupArray(eventBriefQuestionVS).optional(),
    customization: customizationVS.optional(),
    lastMessage: yupString().optional(),
    lastMessageConfirmed: yupIgnore(),
    discriminator: yupIgnore(),
    supplier: yupIgnore(),
    supplierName: yupIgnore(),
    supplyConfirmed: yupIgnore(),
    triggerAssignmentEmail: yupBoolean().required(),
  })

/**
 * VirtualService does not have the supplier details, so we ignore all the related data
 */
const enrichedVirtualServiceVS: YupSchema<EnrichedProductService> =
  enrichedProductServiceVS.shape({
    lastMessage: yupIgnore(),
    lastMessageConfirmed: yupIgnore(),
    supplier: yupIgnore(),
    supplierName: yupIgnore(),
    supplyConfirmed: yupIgnore(),
    triggerAssignmentEmail: yupIgnore(),
  })

export const enrichedProductServicesBundleVS: YupSchema<EnrichedProductServiceBundle> =
  yupObject().shape({
    drinkService: enrichedProductServiceVS,
    foodService: enrichedProductServiceVS,
    rentService: enrichedProductServiceVS,
    musicService: enrichedProductServiceVS,
    locationService: enrichedProductServiceVS,
    physicalService: enrichedProductServiceVS,
    virtualService: enrichedVirtualServiceVS,
  })
